import { useState } from "react";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	IconButton,
	Menu,
	MenuItem,
	Typography,
} from "@mui/material";
import moment from "moment";
import { BsThreeDots } from "react-icons/bs";
import { Link } from "react-router-dom";

import { usePremiumPackage } from "../../../../../hooks/usePremiumPackage";
import { currencyFormatter } from "../../../../../utils";
import { Loading } from "../../../../common/Loading/Loading";

export function Subscriptions() {
	type TState = {
		optionButtonAnchor: HTMLElement | null;
		subscriptionId: string | null;
		confirmDialogOpen: boolean;
	};
	const [state, setState] = useState<TState>({
		optionButtonAnchor: null,
		subscriptionId: null,
		confirmDialogOpen: false,
	});

	const { loading, currentPlans, cancelSubscription } = usePremiumPackage();

	const onClickCloseConfirmDialog = () => {
		setState((prevState) => ({
			...prevState,
			confirmDialogOpen: false,
			subscriptionId: null,
		}));
	};

	const onClickCancelSubscription = () => {
		const subscriptionId = state.subscriptionId;
		onClickCloseConfirmDialog();
		if (!subscriptionId) {
			return;
		}
		cancelSubscription(subscriptionId);
	};

	return (
		<div className="subscriptions-container">
			<Typography className="small-title-text bold">Subscriptions</Typography>
			<div className="current-plans-container item-separator-tiny">
				{currentPlans.map((currentPlan) => (
					<div
						className="current-plan-container"
						key={currentPlan.subscriptionId}>
						<Typography className="normal-text bold">
							{`${currentPlan.packageName} - ${currentPlan.currentPackage.name}`}
						</Typography>
						{currentPlan.canceled_at && (
							<Typography className="normal-text">
								{`Will expire on ${moment(currentPlan.duration.periodEnd * 1000).format("MMMM DD, YYYY")}`}
							</Typography>
						)}
						{!currentPlan.canceled_at && (
							<Typography className="normal-text">
								{`Next bill on ${moment(currentPlan.duration.periodEnd * 1000).format("MMMM DD, YYYY")}`}
							</Typography>
						)}
						<Typography className="normal-text">
							{`${currencyFormatter(currentPlan.currentPackage.currency).format(currentPlan.currentPackage.monthlyPrice)}/month`}
						</Typography>
						<div className="plan-button-container item-separator-tiny">
							<Link
								style={{ flex: 1 }}
								className="no-underline-link"
								to={`/memberships#${currentPlan.packageId}`}>
								<Typography className="view-plan-button normal-text">
									View plan
								</Typography>
							</Link>
							{!currentPlan.canceled_at && (
								<IconButton
									className="icon-button plan-menu-button"
									onClick={(e) => {
										setState((prevState) => ({
											...prevState,
											optionButtonAnchor: e.currentTarget,
											subscriptionId: currentPlan.subscriptionId,
										}));
									}}>
									<BsThreeDots />
								</IconButton>
							)}
						</div>
					</div>
				))}
			</div>
			{currentPlans.length === 0 && (
				<Typography className="normal-text" textAlign="center">
					You have no active subscriptions
				</Typography>
			)}
			<Dialog
				open={state.confirmDialogOpen}
				className="confirm-dialog"
				onClose={onClickCloseConfirmDialog}>
				<DialogContent>
					<Typography className="normal-text">
						Are you sure you want to cancel subscription?
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button className="dialog-button" onClick={onClickCloseConfirmDialog}>
						Oh, no thanks
					</Button>
					<Button className="dialog-button" onClick={onClickCancelSubscription}>
						Yes, I'm sure
					</Button>
				</DialogActions>
			</Dialog>
			<Menu
				open={Boolean(state.optionButtonAnchor)}
				anchorEl={state.optionButtonAnchor}
				className="option-menu"
				onClose={() => {
					setState((prevState) => ({
						...prevState,
						optionButtonAnchor: null,
						subscriptionId: null,
					}));
				}}>
				<MenuItem
					onClick={() => {
						setState((prevState) => ({
							...prevState,
							optionButtonAnchor: null,
							confirmDialogOpen: true,
						}));
					}}
					className="normal-text">
					Cancel subscription
				</MenuItem>
			</Menu>
			{loading && <Loading />}
		</div>
	);
}
